import { type FC } from 'react';

import { BaseOfferStep } from './BaseOfferStep';
import { DefaultOfferCard } from './DefaultOfferCard';
import { useOfferStepLogic } from './useOfferStepLogic';
import { getOffer } from '../../../shared/helpers';
import { useDefaultContractTypePreSelection } from '../../experiments/exp-n-611/hooks/useDefaultContractTypePreSelection';

export const OfferStep: FC = () => {
  const logic = useOfferStepLogic({
    buildSubmitPayload: ({ selectedDiscountCode, flowContext, offer }) => {
      const selectedOffer = getOffer({ ...flowContext, discountCode: selectedDiscountCode }, offer);

      return {
        offerType: selectedOffer?.discountType,
      };
    },
  });

  // exp-n-611 — default contract type. Acquisition offer step only (not the extension flow).
  // Delete this call (and the exp-n-611 folder) to remove the experiment.
  useDefaultContractTypePreSelection({
    isSuccessful: logic.isSuccessful,
    offers: logic.offers,
    selectedDiscountCode: logic.selectedDiscountCode,
    handleValueChange: logic.handleValueChange,
  });

  return (
    <BaseOfferStep
      logic={logic}
      renderOfferCard={offer => (
        <DefaultOfferCard
          key={offer.type}
          isOpen={logic.isPriceDetailsOpen}
          setOpen={logic.setIsPriceDetailsOpen}
          isSelected={offer.type === logic.selectedDiscountCode}
          onSelect={() => {
            if (!offer.type) return;
            logic.setValue('discountCode', offer.type, { shouldValidate: true, shouldDirty: true });
          }}
          offer={offer}
          textualData={logic.textualData}
          flowContext={logic.flowContext}
          energyType={logic.energyType}
        />
      )}
    />
  );
};
